var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgressionStableArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 12,
    viewBox: "0 0 76 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.5303 6.05377C75.8232 5.76087 75.8232 5.286 75.5303 4.99311L70.7574 0.220137C70.4645 -0.0727568 69.9896 -0.0727568 69.6967 0.220137C69.4038 0.51303 69.4038 0.987904 69.6967 1.2808L73.9393 5.52344L69.6967 9.76608C69.4038 10.059 69.4038 10.5338 69.6967 10.8267C69.9896 11.1196 70.4645 11.1196 70.7574 10.8267L75.5303 6.05377ZM0 5.52344L0 6.27344H75V5.52344V4.77344H0L0 5.52344Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressionStableArrow);
export default __webpack_public_path__ + "static/media/progressionStableArrow.b9d50e613b21412626fc78087cf9bce4.svg";
export { ForwardRef as ReactComponent };